import { ArchiveGlyph, PauseGlyph, PlayGlyph } from "./lifecycleIcons";
import { LIFECYCLE_COPY } from "./copy";
import "./lifecycle.css";

/**
 * The Dialogue Detail's state chrome (Figma 11115:27292 / 27429 / 27579):
 * the hero badge and icon actions, and the Paused / Archived banner. Only
 * these and the bottom CTA change by state; the Overview body is unchanged.
 * `view` comes from `lifecycleView(state)`.
 */

const GLYPH = { pause: PauseGlyph, resume: PlayGlyph, archive: ArchiveGlyph };

/** Badge (top centre) and icon buttons (top right) over the hero image. */
export function HeroLifecycle({ view, state, busy, onAction }) {
  if (!view.badge && view.actions.length === 0) return null;
  return (
    <div className="exl-hero">
      {view.badge && (
        <span className={`exl-badge exl-badge--${String(state).toLowerCase()}`}>
          {view.badge}
        </span>
      )}
      {view.actions.length > 0 && (
        <div className="exl-hero__actions">
          {view.actions.map((action) => {
            const Glyph = GLYPH[action];
            return (
              <button
                key={action}
                type="button"
                className="exl-hero__btn"
                aria-label={LIFECYCLE_COPY.aria[action]}
                title={LIFECYCLE_COPY.aria[action]}
                disabled={busy}
                onClick={() => onAction?.(action)}
              >
                <Glyph size={20} />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

/**
 * The Paused banner (with Resume Dialogue) or the Archived one (no button —
 * Archive is final). `onResume` absent hides the Paused button.
 */
export function StateBanner({ state, busy, onResume }) {
  const copy = LIFECYCLE_COPY.banner[state];
  if (!copy) return null;
  const paused = state === "PAUSED";
  return (
    <section
      className={`exl-banner exl-banner--${paused ? "paused" : "archived"}`}
      aria-label={copy.title}
    >
      <div className="exl-banner__row">
        <span className="exl-banner__tile" aria-hidden="true">
          {paused ? <PauseGlyph size={22} /> : <ArchiveGlyph size={22} />}
        </span>
        <span className="exl-banner__text">
          <span className="exl-banner__title">{copy.title}</span>
          <span className="exl-banner__body">{copy.body}</span>
        </span>
      </div>
      {paused && onResume && (
        <button type="button" className="exd-cta__btn" disabled={busy} onClick={onResume}>
          {LIFECYCLE_COPY.resumeCta}
        </button>
      )}
    </section>
  );
}
